import { render, staticRenderFns } from "./abnormal-edit.vue?vue&type=template&id=3fcc7f1b"
import script from "./abnormal-edit.vue?vue&type=script&lang=js"
export * from "./abnormal-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports